import "@/App.css";
import "@/typography.css";
import "@/mobile-fixes.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PartnerLanding from "./pages/PartnerLanding";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PartnerLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
